import axios from 'axios';
import _ from 'lodash';
import { toast } from 'react-toastify';
import { axiosConfig, ThrowErrorMsg } from '../util';
import { getRequest, postRequest, putRequest, deleteRequest } from '../../services.js/apiService';

import {
  GET_PAGE,
  GET_PAGES,
  DELETE_PAGE,
  ADD_PAGE,
  EDIT_PAGE,
  UPDATE_PAGE,
} from '../types';

const basePathV1 = `${process.env.REACT_APP_API_URL}/v1`;
const basePathStaff = `${process.env.REACT_APP_API_URL}/staff`;

export const editPage = (page) => async (dispatch) => {
    dispatch({ type: EDIT_PAGE, payload: page });
};

export const uploadPageImage = (id, file) => async (dispatch) => {
  try {
    const config = {
      validateStatus(status) { return status < 600; },
    };
    const res = await axios.post(
      `${basePathV1}/page/${id}/image`, file, config,
    );

    return res.data;
  } catch (err) {
    ThrowErrorMsg(err, dispatch);
  }
};

export const deletePageImage = (id, imageData, type) => async (dispatch) => {
  try {
    const config = {
      validateStatus(status) { return status < 600; },
    };
    const res = await axios.delete(
      `${basePathV1}/page/${id}/image`,
      {
        data: { imageData, imageType: type }, ...config,
      },
    );

    return res.data;
  } catch (err) {
    ThrowErrorMsg(err, dispatch);
  }
};

export const getPaginatePages = (query) => async (dispatch) => {
  try {
    const params = {
      ...query,
      pageNo: query.page,
    };
    const res = await axios.get(`${basePathV1}/pages`, { params });

    dispatch({
      type:    GET_PAGES,
      payload: res.data,
    });

    return res.data;
  } catch (err) {
    if (err.response !== undefined) {
      const error = err.response.data.message;
      toast.error(error);
    }
  }
};

export const getPage = (id) => async (dispatch) => {
  try {
    const config = {
      validateStatus(status) { return status < 500; },
    };
    const res = await axios.get(`${basePathV1}/page/${id}`, config);
    if (res.status === 200) {
      dispatch({ type: GET_PAGE });
      return res.data;
    } else {
      toast.error(res.data);
      return null;
    }
  } catch (err) {
    toast.error((err.response !== undefined) ? err.response.data : err.message);
    throw err;
  }
};

export const getPagesByParams = (params) => async () => {
  try {
    const pages = await getRequest(`${basePathStaff}/pages`, params);
    return pages;
  } catch (err) {
    ThrowErrorMsg(err);
  }
};

export const getParents = () => async (dispatch) => {
  try {
    const config = {
      validateStatus(status) { return status < 500; },
    };
    const res = await axios.get(`${basePathV1}/pages/parents`, config);
    if (res.status === 200) {
      return res.data;
    } else {
      toast.error(res.data);
      return null;
    }
  } catch (err) {
    toast.error((err.response !== undefined) ? err.response.data : err.message);
    throw err;
  }
};

export const getSubsidiaryPages = () => async (dispatch) => {
  try {
    const config = {
      validateStatus(status) { return status < 500; },
    };
    const res = await axios.get(`${basePathV1}/pages/nonCreditCard`, config);
    if (res.status === 200) {
      return res.data;
    } else {
      toast.error(res.data);
      return null;
    }
  } catch (err) {
    toast.error((err.response !== undefined) ? err.response.data : err.message);
    throw err;
  }
};

export const getCreditCardPagesUnderPage = (id) => async (dispatch) => {
  try {
    const config = {
      validateStatus(status) { return status < 500; },
    };
    const res = await axios.get(`${basePathV1}/page/${id}/subsidiaries/creditcard`, config);
    if (res.status === 200) {
      return res.data;
    } else {
      toast.error(res.data);
      return null;
    }
  } catch (err) {
    toast.error((err.response !== undefined) ? err.response.data : err.message);
    throw err;
  }
};

export const getSubsidiaryPagesUnderPage = (id) => async (dispatch) => {
  try {
    const config = {
      validateStatus(status) { return status < 500; },
    };
    const res = await axios.get(`${basePathV1}/page/${id}/subsidiaries/nonCreditCard`, config);
    if (res.status === 200) {
      return res.data;
    } else {
      toast.error(res.data);
      return null;
    }
  } catch (err) {
    toast.error((err.response !== undefined) ? err.response.data : err.message);
    throw err;
  }
};

export const getPagesByType = (data) => async (dispatch) => {
  const config = {
    validateStatus(status) { return status < 500; },
  };
  const params = {
    ...data,
  };
  try {
    const res = await axios.get(`${basePathV1}/pages/type`, { params, config });
    if (res.status === 200) {
      return res.data;
    } else {
      toast.error(res.data);
      return null;
    }
  } catch (err) {
    toast.error((err.response !== undefined) ? err.response.data : err.message);
    throw err;
  }
};

export const addPage = (data) => async (dispatch) => {
  try {
    const { parentId, name, website, description, facebook, instagram, type, address, postalCode,
      lat, lng, halal, userTags, categoryIds, lastKDays, isViewFnb, payProcessor, prefixCode, isOfficial,
      giftEnabled, showAllPostsInLowLevelMap, tagSearchInMapEnabled } = data;

    const payload = {
      parentId, name, website, description, facebook, instagram, type, address, postalCode,
      lat, lng, halal, userTags, categoryIds, lastKDays, isViewFnb, payProcessor, prefixCode,
      isOfficial, giftEnabled, showAllPostsInLowLevelMap, tagSearchInMapEnabled,
    };

    const page = await postRequest(`${basePathStaff}/page`, payload);

    dispatch({
      type:    ADD_PAGE,
      payload: page,
    });

    return page;
  } catch (err) {
    ThrowErrorMsg(err);
  }
};

export const updatePage = (id, data) => async (dispatch) => {
  try {
    const page = await putRequest(`${basePathStaff}/page/${id}`, data);
    dispatch({
      type:    UPDATE_PAGE,
      payload: page,
    });
    dispatch({
      type:    EDIT_PAGE,
      payload: page,
    });
    return page;
  } catch (err) {
    ThrowErrorMsg(err);
  }
};

export const updateMallMapPageStatus = async (id, mallMapStatus) => {
  try {
    const res = await axios.put(`${basePathV1}/page/${id}`, { mallMapStatus }, axiosConfig);
    return res.data;
  } catch (err) {
    ThrowErrorMsg(err);
  }
};

export const updatePageStatus = (id, status) => async (dispatch) => {
  try {
    const res = await axios.put(
      `${basePathV1}/page/${id}/status`,
      { status },
      axiosConfig,
    );
    dispatch({
      type:    UPDATE_PAGE,
      payload: res.data,
    });
    dispatch({
      type:    EDIT_PAGE,
      payload: res.data,
    });
    return res.data;
  } catch (err) {
    ThrowErrorMsg(err);
  }
};

export const updatePageOpeningHours = (data, id) => async (dispatch) => {
  const config = {
    headers: {
      'Content-Type': 'application/json',
    },
  };
  try {
    const res = await axios.put(
      `${basePathV1}/page/${id}/openingHours`,
      data,
      config,
    );
    toast.success('Opening Hours Updated.');
    return res.data;
  } catch (err) {
    toast.error(err.response.data);
  }
};

export const deletePage = (id) => async (dispatch) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      validateStatus(status) { return status < 600; },
    };
    // await axios.delete(`${basePath}/delete/${id}`);
    const res = await axios.delete(`${basePathV1}/page/${id}`, config);
    if (res.status === 200) {
      dispatch({
        type:    DELETE_PAGE,
        payload: id,
      });
      toast.success('Page Deleted.');
    } else {
      toast.error(res.data);
    }
  } catch (err) {
    if (err.response !== undefined) {
      const error = err.response.data.message;
      toast.error(error);
    }
  }
};

export const getMalls = () => async (dispatch) => {
  try {
    const res = await axios.get(`${basePathV1}/pages/type?type=Mall`);
    return res.data;
  } catch (err) {
    if (err.response !== undefined) {
      const error = err.response.data.message;
      toast.error(error);
    }
  }
};

export const getPostsByBrandAndTag = (params) => async (dispatch) => getRequest(`${basePathStaff}/page/posts/brandAndTag`, params);
export const getPinnedPosts = (params) => async (dispatch) => getRequest(`${basePathStaff}/page/${params.pageId}/pinnedPosts`, params);
export const getPagePostsExceptHighlights = (params) => async (dispatch) => getRequest(`${basePathStaff}/page/${params.pageId}/pagePostsExceptHighlights`, params);
export const addPinnedPost = (params) => async (dispatch) => postRequest(`${basePathStaff}/page/pinnedPost`, params);
export const deletePinnedPost = (pageId, postId) => async (dispatch) => deleteRequest(`${basePathStaff}/page/${pageId}/pinnedPost/${postId}`);
export const updatePinnedPostOrder = (params) => async (dispatch) => putRequest(`${basePathStaff}/page/${params.pageId}/pinnedPostOrder`, params);
export const updatePinnedPost = (params) => async (dispatch) => putRequest(`${basePathStaff}/page/${params.pageId}/pinnedPost`, params);

export const getPagesByCatId = (catId) => async (dispatch) => {
  try {
    const res = await axios.get(`${basePathV1}/pages/category/${catId}`);
    return res.data;
  } catch (err) {
    if (err.response !== undefined) {
      const error = err.response.data.message;
      toast.error(error);
    }
  }
};
